import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import ES from './languages/es.json';
import EN from './languages/en.json';

const resources = {
  es: {
    translation: ES
  },
  en: {
    translation: EN
  }
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources,
    // Solo hay recursos `es` y `en`, y LanguageDetector toma el idioma del
    // navegador: sin estas dos líneas, alguien con el navegador en otro idioma
    // caía en el pseudo-idioma `dev` de i18next y veía las LLAVES crudas en
    // lugar del texto. `supportedLngs` además normaliza variantes regionales
    // (es-MX -> es) — de ahí sale el locale que usa el selector de fechas.
    fallbackLng: 'es',
    supportedLngs: ['es', 'en'],
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
